import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {getAliVodsTokenRequest,getAliOssTokenRequest} from "../api";

var script1 = document.createElement('script');
script1.type = 'text/javascript';
script1.async = true;
script1.src = 'https://spark-gamepku.oss-cn-qingdao.aliyuncs.com/tbi/aliyun-upload-sdk-1.5.7.min.js';
document.head.appendChild(script1);

var script2 = document.createElement('script');
script2.type = 'text/javascript';
script2.async = true;
script2.src = 'https://spark-gamepku.oss-cn-qingdao.aliyuncs.com/tbi/aliyun-oss-sdk-6.17.1.min.js';
document.head.appendChild(script2);

class AliyunVodUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            uploadPercentage: 0,
            uploadSize:0,
            uploadStatus: 'ready', // ready, uploading, success, error
            videoId: '',
            errorMessage: ''
        };
        this.uploader = null;
        this.fileInputRef = React.createRef();
    }

    // 初始化上传器
    initUploader = (file) => {
        const {regionId, uploadCallback} = this.props;

        var that = this

        // 创建上传对象
        that.uploader = new window.AliyunUpload.Vod({
            // userID，用于标识上传者的身份，必填，有值即可，可以是阿里云账号ID或者您自定义的用户ID，您可以访问阿里云账号中心（https://account.console.aliyun.com/）查看账号ID
            userId: "122",
            // 上传到视频点播的地域，默认值为'cn-shanghai'，
            //eu-central-1，ap-southeast-1
            region: "",
            // 分片大小默认1 MB，不能小于100 KB（100*1024）
            partSize: 1048576,
            // 并行上传分片个数，默认5
            parallel: 5,
            // 网络原因失败时，重新上传次数，默认为3
            retryCount: 3,
            // 网络原因失败时，重新上传间隔时间，默认为2秒
            retryDuration: 2,
            // 开始上传
            onUploadstarted: function (uploadInfo) {
                console.log('开始上传')
                console.log(uploadInfo);
                getAliVodsTokenRequest((data) => {
                    var stsToken = data.Credentials
                    that.uploader.setSTSToken(uploadInfo, stsToken.AccessKeyId, stsToken.AccessKeySecret, stsToken.SecurityToken)
                })
            },
            // 文件上传成功
            onUploadSucceed: function (uploadInfo) {
                console.log('上传完成')
                console.log(uploadInfo);
            },
            // 文件上传失败
            onUploadFailed: function (uploadInfo, code, message) {
            },
            // 文件上传进度，单位：字节
            onUploadProgress: function (uploadInfo, totalSize, loadedPercent) {
                console.log("onUploadProgress:file:" + uploadInfo.file.name + ", fileSize:" + totalSize + ", percent:" + Math.ceil(loadedPercent * 100) + "%")
                var progressPercent = Math.ceil(loadedPercent * 100)
                that.setState({
                    uploadPercentage:progressPercent,
                    uploadSize:totalSize * loadedPercent
                })
                console.log(progressPercent)
                console.log('文件上传中...')
            },
            // 上传凭证或STS token超时
            onUploadTokenExpired: function (uploadInfo) {
                getAliVodsTokenRequest((data) => {
                    var stsToken = data.Credentials
                    that.uploader.resumeUploadWithSTSToken(uploadInfo, stsToken.AccessKeyId, stsToken.AccessKeySecret, stsToken.SecurityToken)
                })
            },
            // 全部文件上传结束
            onUploadEnd: function (uploadInfo) {
            },
        });
        console.log("ssssssssssssssssssssssssssssssssssssssssssssss");
        console.log(file);
        var Title = file.name;
        var userData = '{"Vod":{"Title":"' + Title + '"}}';
        // 添加文件并开始上传
        // this.uploader.addFile(file, null, null, null, {
        //     title: file.name,
        //     fileName: file.name
        // });
        console.log('0---------------')
        console.log(userData);
        this.uploader.addFile(file, null, null, null, userData);
        this.uploader.startUpload();
        this.setState({uploadStatus: 'uploading'});
    }


    // 处理文件选择
    handleFileSelect = (e) => {
        const file = e.target.files[0];
        if (file) {
            this.initUploader(file);
        }
    }

    // 处理上传按钮点击
    handleUploadClick = () => {
        this.fileInputRef.current.click();
    }

    // 渲染上传状态
    renderUploadStatus = () => {
        const {uploadStatus, uploadPercentage,uploadSize, errorMessage, videoId} = this.state;

        if (uploadStatus === 'ready') {
            return (
                <div className="upload-status text-gray-500">
                    准备上传...
                </div>
            );
        }

        if (uploadStatus === 'uploading') {
            return (
                <div className="upload-status">
                    <div className="progress-bar bg-gray-200 rounded-full h-2.5 w-full">
                        <div className="bg-blue-600 h-2.5 rounded-full" style={{width: `${uploadPercentage}%`}}></div>
                    </div>
                    <div className="text-sm text-gray-600 mt-1">
                        上传中: {uploadPercentage.toFixed(1)}% - {this.formatFileSize(uploadSize)}
                    </div>
                </div>
            );
        }

        if (uploadStatus === 'success') {
            return (
                <div className="upload-status text-green-500">
                    <div className="flex items-center">
                        <i className="fa fa-check-circle mr-2"></i>
                        <span>上传成功！视频ID: {videoId}</span>
                    </div>
                </div>
            );
        }

        if (uploadStatus === 'error') {
            return (
                <div className="upload-status text-red-500">
                    <div className="flex items-center">
                        <i className="fa fa-exclamation-circle mr-2"></i>
                        <span>{errorMessage}</span>
                    </div>
                </div>
            );
        }

        return null;
    }

    // 格式化文件大小
    formatFileSize = (bytes) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }

    render() {
        return (
            <div className="aliyun-vod-uploader">
                <div className="upload-container p-6 border-2 border-dashed border-gray-300 rounded-lg text-center">
                    <button
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mb-4 transition duration-300 ease-in-out transform hover:scale-105"
                        onClick={this.handleUploadClick}
                    >
                        <i className="fa fa-cloud-upload mr-2"></i>选择视频上传
                    </button>

                    <input
                        type="file"
                        accept="video/*"
                        ref={this.fileInputRef}
                        style={{display: 'none'}}
                        onChange={this.handleFileSelect}
                    />

                    {this.renderUploadStatus()}
                </div>

                <div className="upload-tips mt-4 text-sm text-gray-500">
                    <p>支持常见视频格式，最大文件大小取决于阿里云账号权限</p>
                </div>
            </div>
        );
    }
}

AliyunVodUpload.propTypes = {
    stsServerUrl: PropTypes.string.isRequired,
    regionId: PropTypes.string,
    uploadCallback: PropTypes.func
};

AliyunVodUpload.defaultProps = {
    regionId: 'cn-beijing',
    uploadCallback: () => {
    }
};

export default AliyunVodUpload;